import React, { useState } from "react";
import { observer } from "mobx-react";

import {
  IconButton,
  InputAdornment,
  FormHelperText,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IMaskInput } from "react-imask";

import "../index.css";

function PasswordField(props) {
  const {
    id,
    label,
    //value,
    error,
    helperText,
    className,
    variant,
    type,
    mask,
    maskDefinitions,
    ...other
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const InputMaskCustom = React.forwardRef(function InputMaskCustom(
    props,
    ref
  ) {
    const { onChange, ...otherp } = props;
    return (
      <IMaskInput
        inputRef={ref}
        {...otherp}
        mask={mask}
        definitions={
          maskDefinitions ?? { 9: /[0-9]/, /*a: /[a-z]/,*/ "#": /[0-9, a-z]/ }
        }
        onAccept={(value) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  });
  const component = mask && { inputComponent: InputMaskCustom };
  return (
    <FormControl className={className} variant={variant} error={error}>
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        //className={className}
        id={id}
        label={label}
        autoComplete="new-password"
        type={showPassword ? type || "text" : "password"}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={
                showPassword ? "hide the password" : "display the password"
              }
              onClick={handleClickShowPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        {...component}
        {...other}
      />

      <FormHelperText id={`${id}ht`}>{helperText}</FormHelperText>
    </FormControl>
  );
}
export default observer(PasswordField);
